module.exports = __webpack_public_path__ + "img/51462B_DFCA7E_948050_A49874-256px.2551ce2d.png";